import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useCallback, useMemo } from 'react';
import { Menu } from '../../components/Menu';
export const ANNOTATION_COLORS = [
    '#ff0000', // red
    '#ff8800', // orange
    '#ffdd00', // yellow
    '#00cc00', // green
    '#00cccc', // turquoise
    '#0066ff', // blue
    '#8800ff', // purple
    '#ff66cc', // pink
    '#ffffff', // white
    '#000000', // black
];
export const ColorPicker = React.memo(function ColorPicker({ activeColor, onColorChange, }) {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const handleToggle = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);
    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);
    const items = useMemo(() => ANNOTATION_COLORS.map((color) => ({
        id: color,
        type: 'custom',
        render: () => (_jsx("span", { className: `hekate-annotation-color-option${color === activeColor ? ' hekate-annotation-color-option--active' : ''}`, style: { backgroundColor: color }, "aria-label": color })),
        onClick: () => {
            onColorChange(color);
            setIsOpen(false);
        },
    })), [activeColor, onColorChange]);
    return (_jsxs("div", { className: "hekate-annotation-color-picker", children: [_jsx("button", { ref: buttonRef, className: "hekate-annotation-toolbar-btn hekate-annotation-color-btn", onClick: handleToggle, "aria-label": `Color: ${activeColor}`, "aria-haspopup": "true", "aria-expanded": isOpen, "data-tooltip": "Color", type: "button", children: _jsx("span", { className: "hekate-annotation-color-swatch", style: { backgroundColor: activeColor } }) }), _jsx("div", { className: "hekate-annotation-color-menu", children: _jsx(Menu, { items: items, isOpen: isOpen, onClose: handleClose, ariaLabel: "Select color", triggerRef: buttonRef, layout: "grid", gridColumns: 5 }) })] }));
});
